import { Icon, type MenuItem } from '@ics-portal/guardian';
import { type ReactNode, useEffect, useMemo, useState } from 'react';
import InfoCardWrapper from '@components/_molecules/InfoCards/Layout/InfoCardWrapper';
import { ComponentCreateRequestStatusCode } from '@gql/graphql';
import { type RequestProps } from '../../models/RequestProps';
import { EditRequestContent } from './EditRequestContent';
import { RequestDetailsContent } from './RequestDetailsContent';

interface RequestDetailsTabProps extends RequestProps {
    actions?: MenuItem[];
}

export function RequestDetailsTab({
    request,
    actions: requestActions = [],
}: RequestDetailsTabProps): ReactNode {
    const [editMode, setEditMode] = useState<boolean>(false);

    useEffect(() => {
        setEditMode(false);
    }, [request.id]);

    const title = useMemo(
        () => (editMode ? 'Edit Request' : 'Details'),
        [editMode],
    );

    const actions: MenuItem[] = useMemo(() => {
        if (editMode) {
            return [];
        }

        const editActions: MenuItem[] = [];

        if (
            request.statusCode ===
            ComponentCreateRequestStatusCode.ApprovalPending
        ) {
            editActions.push({
                label: 'Edit',
                icon: <Icon name="edit" />,
                command: () => {
                    setEditMode(true);
                },
            });
        }

        return [...editActions, ...requestActions];
    }, [request, editMode, requestActions]);

    return (
        <InfoCardWrapper title={title} actions={actions} className="pb-0">
            {!editMode && <RequestDetailsContent request={request} />}
            {editMode ? (
                <EditRequestContent
                    request={request}
                    disableEditMode={() => {
                        setEditMode(false);
                    }}
                />
            ) : null}
        </InfoCardWrapper>
    );
}
